import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const EXPIRED = new Set(["Session expired", "Invalid token", "User not found", "This account has been disabled"]);
api.interceptors.response.use(undefined, (error) => {
  const detail = error?.response?.data?.detail;
  const hadToken = !!error?.config?.headers?.Authorization;
  if (error?.response?.status === 401 && hadToken && EXPIRED.has(detail)) {
    ["fl_token", "fl_admin_token"].forEach((k) => localStorage.removeItem(k));
    if (!window.__flSessionReload) {
      window.__flSessionReload = true;
      window.dispatchEvent(new CustomEvent("fl:session-expired"));
      setTimeout(() => window.location.reload(), 300);
    }
  }
  return Promise.reject(error);
});

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    const msgs = d.map((x) => (x.msg || JSON.stringify(x)).replace(/^Value error,\s*/, ""));
    return [...new Set(msgs)].join(" ");
  }
  return e?.message || "Something went wrong";
};

export const media = (url) => (url?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);

// A browser that has passed 2FA stays trusted for the window set in Admin → Settings,
// so a fresh sign-in inside that window skips the code.
export const mfaTrust = {
  get: () => localStorage.getItem("fl_mfa_trust") || "",
  save: (data) => {
    if (data?.mfa_trust_token) localStorage.setItem("fl_mfa_trust", data.mfa_trust_token);
  },
};
